import { render, staticRenderFns } from "./SearchHead.vue?vue&type=template&id=164f905e&scoped=true"
import script from "./SearchHead.vue?vue&type=script&lang=js"
export * from "./SearchHead.vue?vue&type=script&lang=js"
import style0 from "./SearchHead.vue?vue&type=style&index=0&id=164f905e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f905e",
  null
  
)

export default component.exports